'use strict';

customersController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$uibModal',
	'$filter',
	'$interval',
	'dialogHelper',
	'reportHelper',
	'customerService',
	'accountService',
	'accountStructureService',
	'siteService',
	'unitService',
	'utilsService',
	'authService',
	'ACCOUNT_TYPES',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
	'ROLE_CLAIMS',
];
angular.module('schoolLinqApp').controller('customersController', customersController);

function customersController(
	$scope,
	$rootScope,
	$q,
	$uibModal,
	$filter,
	$interval,
	dialogHelper,
	reportHelper,
	customerService,
	accountService,
	accountStructureService,
	siteService,
	unitService,
	utilsService,
	authService,
	ACCOUNT_TYPES,
	USER_CLAIMS,
	BUSY_MESSAGE,
	ROLE_CLAIMS
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.$watch(
		'vm.filter.sitesToShow',
		function (sitesToShow) {
			var selectedItems = 0;
			for (var index = 0; index < sitesToShow.length; index++) {
				if (sitesToShow[index].Selected) {
					selectedItems++;
				}

				$scope.vm.filter.numberOfSelectedItems = selectedItems;

				if (selectedItems === sitesToShow.length) {
					$scope.vm.filter.allSelected = true;
				} else {
					$scope.vm.filter.allSelected = false;
				}
			}
		},
		true
	);

	$scope.$watch(
		'vm.backupFilter.sitesToShow',
		function (sitesToShow) {
			if (typeof sitesToShow === 'undefined' || sitesToShow === null) {
				return;
			}

			var selectedItems = 0;
			for (var index = 0; index < sitesToShow.length; index++) {
				if (sitesToShow[index].Selected) {
					selectedItems++;
				}

				$scope.vm.backupFilter.numberOfSelectedItems = selectedItems;

				if (selectedItems === sitesToShow.length) {
					$scope.vm.backupFilter.allSelected = true;
				} else {
					$scope.vm.backupFilter.allSelected = false;
				}
			}
		},
		true
	);

	$scope.$watch(
		'vm.selectedCustomerSites',
		function (selectedCustomerSites) {
			if (typeof selectedCustomerSites === 'undefined' || selectedCustomerSites === null) {
				return;
			}

			var selectedItems = 0;
			for (var index = 0; index < selectedCustomerSites.length; index++) {
				if (selectedCustomerSites[index].Selected) {
					selectedItems++;
				}

				$scope.vm.selectedCustomerSitesPaging.numberOfSelectedItems = selectedItems;

				if (selectedItems === selectedCustomerSites.length) {
					$scope.vm.selectedCustomerSitesPaging.allSelected = true;
				} else {
					$scope.vm.selectedCustomerSitesPaging.allSelected = false;
				}
			}
		},
		true
	);

	$scope.busyPromise = $q.all([
		$scope.vm.loadCustomerStatuses($scope.vm),
		$scope.vm.loadSites($scope.vm),
		$scope.vm.loadAccountStructures($scope.vm),
		$scope.vm.loadCustomers($scope.vm),
		$scope.vm.loadStates($scope.vm),
		$scope.vm.loadBillingMethods($scope.vm),
		$scope.vm.loadUnitEventHubCustomerId($scope.vm),
	]);

	function getViewModel(moduleName) {
		var now = new Date();
		var fieldClaims = authService.authentication.fieldClaims;

		var docMgmtPermission = null; // authService.hasPageClaim(payableClaims, 'FundCashCustomerAccountsReceivableDocMgmt', USER_CLAIMS.fund, 'cash');

		var model = {
			module: moduleName,
			isGA: authService.authentication.isGA,
			busyMessage: BUSY_MESSAGE.Loading,
			accountTypeIds: ACCOUNT_TYPES,
			unifiedAccountMask: null,
			revenueAccountMask: null,
			customerStatuses: [],
			customers: [],
			sites: [],
			states: [],
			billingMethods: [],
			eventHubCustomerId: null,
			canDeleteSelectedCustomer: false,
			selectedCustomer: null,
			backupCustomer: null,
			selectedCustomerSites: null,
			backupCustomerSites: null,
			selectedCustomerSitesPaging: {
				search: '',
				barLimit: 8,
				startIndex: 0,
				numberOfSelectedItems: 0,
				allSelected: true,
			},
			barLimit: 12,
			startIndex: 0,
			filter: {
				tab: 'General',
				search: '',
				customerStatus: null,
				sitesToShow: [],
				barLimit: 12,
				startIndex: 0,
				numberOfSelectedItems: 0,
				allSelected: true,
				propertyName: 'CustomerName',
				reverse: false,
			},
			receipts: {
				receipts: [],
				filter: {
					barLimit: 8,
					startIndex: 0,
					arInvoiceStatusId: 1,
					deposited: true,
					toDate: moment(now).startOf('day').toDate(),
					fromDate: moment(now.setMonth(now.getMonth() - 2))
						.startOf('day')
						.toDate(),
					propertyName: 'ReceiptNumber',
					reverse: false,
				},
			},
			filteredReceiptList: [],
			invoices: {
				invoices: [],
				filter: {
					barLimit: 8,
					startIndex: 0,
					arInvoiceStatusId: 1,
					deposited: true,
					propertyName: 'InvoiceNumber',
					reverse: false,
				},
			},
			viewArInvoice: {
				images: [],
				activeImage: 0,
				readOnly: true,
			},
			backupFilter: null,
			errors: null,
			isAddAllowed: authService.isReadOnly(USER_CLAIMS.lsb, 'Customers', 'cash'),
			isReadOnly: authService.isReadOnly(USER_CLAIMS.lsb, 'Customers', 'cash'),
			isReceivableActive: authService.isReceivableActive(moduleName),
			docMgmt: {
				permissionLevel: docMgmtPermission,
				hasDeleteAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundCashCustomerAccountsReceivableDocMgmtDelete,
				}),
			},
		};

		function setReadOnly() {
			$scope.vm.isReadOnly = authService.isReadOnly(USER_CLAIMS.lsb, 'Customers', 'cash');
			if (!model.isGA && model.eventHubCustomerId.toString() === model.selectedCustomer.Id.toString()) {
				$scope.vm.isReadOnly = true;
			}
		}

		function selectAllFilterSites(model) {
			var setTo;
			if (model.backupFilter.allSelected) {
				setTo = false;
			} else {
				setTo = true;
			}
			for (var index = 0; index < model.backupFilter.sitesToShow.length; index++) {
				model.backupFilter.sitesToShow[index].Selected = setTo;
			}
		}

		function selectAllCustomerSites(model) {
			var setTo;
			if (model.selectedCustomerSitesPaging.allSelected) {
				setTo = false;
			} else {
				setTo = true;
			}
			for (var index = 0; index < model.selectedCustomerSites.length; index++) {
				model.selectedCustomerSites[index].Selected = setTo;
			}
		}

		function showFilterDialog(model) {
			model.backupFilter = angular.copy(model.filter);
			$uibModal.open({
				template: require('@ajs/templates/fund/customer-filter-modal.html'),
				backdrop: 'static',
				keyboard: false,
				scope: $scope,
				controller: [
					'$scope',
					'$uibModalInstance',
					function ($scope, modalInstance) {
						angular.extend($scope, {
							cancel: function () {
								modalInstance.close();
							},
							done: function () {
								model.filter = angular.copy(model.backupFilter);
								modalInstance.close();
							},
						});
					},
				],
			});
		}

		function filterCustomerList(model, customer) {
			if (model.filter.customerStatus !== null && model.filter.customerStatus.Description !== 'No Filter') {
				if (customer.Active !== model.filter.customerStatus.Description) {
					return false;
				}
			}

			var sitesFiltered = model.filter.sitesToShow.filter(function (value) {
				return value.Selected;
			});

			var siteIdsFiltered = _.map(sitesFiltered, function (currentObject) {
				return currentObject.Id;
			});

			for (var index = 0; index < customer.CustomerSites.length; index++) {
				var customerSiteId = customer.CustomerSites[index];

				if (siteIdsFiltered.indexOf(customerSiteId) >= 0) {
					return true;
				}
			}
			return false;
		}

		function loadCustomerStatuses(model) {
			model.customerStatuses = customerService.getCustomerStatuses();
			model.filter.selectedCustomer = model.customerStatuses[0];
		}

		function formIsDirty() {
			return $scope.generalForm.$dirty || $scope.sitesForm.$dirty;
		}

		function changeTab(model, tab) {
			dialogHelper.dirtyDialog(model.formIsDirty, model.cancelSave, null, acceptFunction);

			function acceptFunction() {
				model.filter.tab = tab;
			}
		}

		function save(model) {
			$scope.generalForm.$setSubmitted();
			$scope.receiptsForm.$setSubmitted();
			$scope.invoicesForm.$setSubmitted();
			$scope.sitesForm.$setSubmitted();
			if (
				model.isReadOnly ||
				(!$scope.generalForm.$valid && model.filter.tab === 'General') ||
				(!$scope.receiptsForm.$valid && model.filter.tab === 'Receipts') ||
				(!$scope.invoicesForm.$valid && model.filter.tab === 'Invoices') ||
				(!$scope.sitesForm.$valid && model.filter.tab === 'Sites')
			)
				return false;

			var associatedSiteIds = _.map(
				model.selectedCustomerSites.filter(function (value) {
					return value.Selected === true;
				}),
				function (currentObject) {
					return currentObject.Id;
				}
			);

			model.selectedCustomer.associatedSiteIds = associatedSiteIds;
			if (model.selectedCustomer.Account) {
				model.selectedCustomer.ReceivablesAccountId = model.selectedCustomer.Account.Id;
			} else {
				model.selectedCustomer.ReceivablesAccountId = null;
			}

			model.busyMessage = BUSY_MESSAGE.Saving;
			$scope.busyPromise = customerService.updateCustomer(model.selectedCustomer, associatedSiteIds).then(_.partial(finishSaving, model));

			function finishSaving(model, response) {
				if (response.data.isValid) {
					$scope.generalForm.$setPristine();
					$scope.receiptsForm.$setPristine();
					$scope.invoicesForm.$setPristine();
					$scope.sitesForm.$setPristine();
					model.backupCustomer = angular.copy(model.selectedCustomer);
					model.backupCustomerSites = angular.copy(model.selectedCustomerSites);
					model.errors = response.data.errors;
					model.busyMessage = BUSY_MESSAGE.Loading;
					$scope.busyPromise = loadCustomers($scope.vm).then(function () {
						model.selectedCustomerSitesPaging.startIndex = 0;
						return selectCustomer($scope.vm, model.selectedCustomer.Id);
					});
				} else {
					model.errors = response.data.errors;
				}
			}
		}

		function searchAccountsbyAccountNumber(model, value, accountTypeId) {
			return accountService.searchAccount(accountTypeId, '', value, 8, true).then(_.partial(finishSearchAccounts, model));

			function finishSearchAccounts(model, response) {
				return response.data.accounts;
			}
		}

		function cancelSave(model) {
			$scope.generalForm.$setPristine();
			$scope.receiptsForm.$setPristine();
			$scope.invoicesForm.$setPristine();
			$scope.sitesForm.$setPristine();
			$scope.generalForm.$setUntouched();
			$scope.receiptsForm.$setUntouched();
			$scope.invoicesForm.$setUntouched();
			$scope.sitesForm.$setUntouched();
			model.selectedCustomer = angular.copy(model.backupCustomer);
			model.selectedCustomerSites = angular.copy(model.backupCustomerSites);
		}

		function selectCustomer(model, id) {
			dialogHelper.dirtyDialog(model.formIsDirty, model.cancelSave, null, acceptFunction);

			function acceptFunction() {
				model.busyMessage = BUSY_MESSAGE.Loading;
				$scope.busyPromise = customerService.getCustomer(id).then(_.partial(finishLoadingCustomer, model));
			}

			function finishLoadingCustomer(model, response) {
				if (response.data.isValid) {
					model.selectedCustomer = response.data.customer;
					model.canDeleteSelectedCustomer = response.data.customer.CanDelete;
					model.receipts.receipts = response.data.customer.Receipts;
					model.invoices.invoices = response.data.customer.ARInvoices;

					$scope.vm.setReadOnly();

					model.selectedCustomerSites = [];
					for (var index = 0; index < model.filter.sitesToShow.length; index++) {
						var siteIdActive = model.selectedCustomer.CustomerSites
							? model.selectedCustomer.CustomerSites.filter(function (value) {
									return value.SiteId === model.filter.sitesToShow[index].Id;
							  }).length > 0
							: 0;

						model.selectedCustomerSites.push({
							SiteName: model.filter.sitesToShow[index].SiteName,
							Id: model.filter.sitesToShow[index].Id,
							Selected: siteIdActive,
						});
					}

					model.selectedCustomerSites = model.selectedCustomerSites.sort(function (a, b) {
						if (a.Selected === true && b.Selected === false) {
							return -1;
						} else if (a.Selected === false && b.Selected === true) {
							return 1;
						} else {
							if (a.SiteName < b.SiteName) {
								return -1;
							} else if (a.SiteName > b.SiteName) {
								return 1;
							} else {
								return 0;
							}
						}
					});

					model.backupCustomer = angular.copy(model.selectedCustomer);
					model.backupCustomerSites = angular.copy(model.selectedCustomerSites);
				} else {
					model.errors = response.data.errors;
				}

				return angular.noop;
			}
		}

		function addCustomer(model) {
			dialogHelper.dirtyDialog(model.formIsDirty, resetForm, null, acceptFunction);

			function acceptFunction() {
				model.showAddCustomer(model);
			}

			function resetForm() {
				model.selectedCustomer = null;
				$scope.generalForm.$setPristine();
				$scope.receiptsForm.$setPristine();
				$scope.invoicesForm.$setPristine();
				$scope.sitesForm.$setPristine();
			}
		}

		function showAddCustomer(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/customer-add-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					size: 'topMoveUp',
					controller: [
						'$scope',
						'$uibModalInstance',
						'customerService',
						function ($scope, modalInstance, customerService) {
							angular.extend($scope, {
								cancel: function () {
									modalInstance.close();
								},
								save: function () {
									if (!$scope.customerForm.$valid) return false;

									if ($scope.newCustomer.ReceivablesAccount) {
										$scope.newCustomer.ReceivablesAccountId = $scope.newCustomer.ReceivablesAccount.Id;
									}

									if ($scope.newCustomer.BillingMethod) {
										$scope.newCustomer.BillingMethodId = $scope.newCustomer.BillingMethod.Id;
									}
									$scope.savingPromise = customerService.addCustomer($scope.newCustomer).then(function (response) {
										if (response.data.isValid) {
											modalInstance.close(response.data.customerId);
										} else {
											$scope.errors = response.data.errors;
										}
									});
								},
							});
						},
					],
				})
				.result.then(function (customerId) {
					if (customerId) {
						model.busyMessage = BUSY_MESSAGE.Loading;
						$scope.busyPromise = model.loadCustomers($scope.vm).then(function () {
							return selectCustomer($scope.vm, customerId);
						});
					}
				});
		}

		function deleteCustomer(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/customer-delete-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						'customerService',
						function ($scope, modalInstance, customerService) {
							angular.extend($scope, {
								cancel: function () {
									modalInstance.close(false);
								},
								delete: function () {
									$scope.deletingPromise = customerService.deleteCustomer($scope.vm.selectedCustomer.Id).then(function (response) {
										if (response.data.isValid) {
											modalInstance.close(true);
										} else {
											$scope.errors = response.data.errors;
										}
									});
								},
							});
						},
					],
				})
				.result.then(function (success) {
					if (success) {
						model.busyMessage = BUSY_MESSAGE.Loading;
						$scope.busyPromise = loadCustomers($scope.vm).then(function () {
							$scope.vm.selectedCustomer = null;
						});
					}
				});
		}

		function loadAccountStructures(model) {
			return accountStructureService.getStructure().then(_.partial(finishLoadingAccountStructures, model));

			function finishLoadingAccountStructures(model, response) {
				let accountStructures = response.data.accountStructure;
				model.unifiedAccountMask = accountStructures.UnifiedAccountMask;
				// we will only show the mask if there is a unified mask
				//model.revenueAccountMask = accountStructures.RevenueAccountMask;
				model.revenueAccountMask = model.unifiedAccountMask;
				return angular.noop;
			}
		}

		function loadCustomers(model) {
			return customerService.getCustomers().then(_.partial(finishLoadingCustomers, model));

			function finishLoadingCustomers(model, response) {
				model.customers = response.data.customers;
				return angular.noop;
			}
		}

		function loadUnitEventHubCustomerId(model) {
			return unitService.getValue('EventHubCustomerId').then(_.partial(finishGetUnitEventHubCustomerId, model));

			function finishGetUnitEventHubCustomerId(model, response) {
				model.eventHubCustomerId = response.data.value;
				return angular.noop;
			}
		}

		function loadStates(model) {
			return utilsService.getStates().then(_.partial(finishLoadingStates, model));

			function finishLoadingStates(model, response) {
				var country = _.find(response.data.states, function (c) {
					if (c.CountryCode === 'US') {
						return c;
					}
				});

				model.states = country.StateCodes;
				return angular.noop;
			}
		}

		function loadSites(model) {
			return siteService.getSites().then(_.partial(finishedLoadingSites, model));

			function finishedLoadingSites(model, response) {
				model.startIndex = 0;
				for (var index = 0; index < response.data.sites.length; index++) {
					model.filter.sitesToShow.push({
						SiteName: response.data.sites[index].SiteName,
						Id: response.data.sites[index].Id,
						Selected: true,
					});
				}

				model.filter.sitesToShow = model.filter.sitesToShow.sort(function (a, b) {
					if (a.SiteName < b.SiteName) {
						return -1;
					} else if (a.SiteName > b.SiteName) {
						return 1;
					} else {
						return 0;
					}
				});

				model.backupFilter = angular.copy(model.filter);
				return angular.noop;
			}
		}

		function loadBillingMethods(model) {
			return utilsService.getBillingMethods().then(_.partial(finishLoadingBillingMethods, model));

			function finishLoadingBillingMethods(model, response) {
				model.billingMethods = response.data.billingMethods;
			}
		}

		function filterReceiptList(model, receipt) {
			if (receipt.Deposited === model.receipts.filter.deposited) {
				if (model.receipts.filter.deposited === true) {
					if (model.receipts.filter.fromDate && model.receipts.filter.toDate) {
						return moment(receipt.DepositDT).isBetween(model.receipts.filter.fromDate, model.receipts.filter.toDate, null, '[]');
					} else if (model.receipts.filter.fromDate) {
						return moment(receipt.DepositDT).isSameOrAfter(model.receipts.filter.fromDate);
					} else if (model.receipts.filter.toDate) {
						return moment(receipt.DepositDT).isSameOrBefore(model.receipts.filter.toDate);
					}
					return true;
				} else {
					return true;
				}
			} else {
				return false;
			}
		}

		function viewReceipt(model, receiptId) {
			var url = '/api/receipts/' + receiptId + '/pdf';
			reportHelper.getReport($scope, url, null, 'Receipt.pdf');
		}

		function viewInvoice(model, invoiceId) {
			var url = '/api/arinvoice/pdf/?invoiceId=' + invoiceId;
			reportHelper.getReport($scope, url, null, 'ARInvoice.pdf');
		}

		function printList(model) {
			var receiptIds = _.pluck(
				$filter('orderBy')(model.filteredReceiptList, model.receipts.filter.propertyName, model.receipts.filter.reverse),
				'ReceiptNumber'
			);

			if (receiptIds.length === 0) return;

			$scope.isReportFinished = false;
			model.busyMessage = BUSY_MESSAGE.GeneratingReport;
			$scope.busyPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			// build filter text
			var filters = [];
			if (model.selectedCustomer) {
				filters.push('Customer: ' + model.selectedCustomer.CustomerName);
			}
			if (model.receipts.filter.deposited === true) {
				if (model.receipts.filter.fromDate && model.receipts.filter.toDate) {
					filters.push(
						'Date from ' +
							moment(model.receipts.filter.fromDate).format('MM/DD/YYYY') +
							' to ' +
							moment(model.receipts.filter.toDate).format('MM/DD/YYYY')
					);
				} else if (model.receipts.filter.fromDate) {
					filters.push('Date from ' + moment(model.receipts.filter.fromDate).format('MM/DD/YYYY'));
				} else if (model.receipts.filter.toDate) {
					filters.push('Date to ' + moment(model.receipts.filter.toDate).format('MM/DD/YYYY'));
				}
				filters.push('Receipt Status: Deposited');
			} else {
				filters.push('Receipt Status: Undeposited');
			}
			var filterText = filters.join('; ');

			var report = {
				ReceiptIds: receiptIds,
				FilterText: filterText,
			};

			reportHelper.postReport($scope, '/api/receipts/print-list', report, 'ReceiptListing.pdf');
		}

		function sortReceiptsBy(model, propertyName) {
			model.receipts.filter.reverse = model.receipts.filter.propertyName === propertyName ? !model.receipts.filter.reverse : false;
			model.receipts.filter.propertyName = propertyName;
		}

		function sortInvoicesBy(model, propertyName) {
			model.invoices.filter.reverse = model.invoices.filter.propertyName === propertyName ? !model.invoices.filter.reverse : false;
			model.invoices.filter.propertyName = propertyName;
		}

		function sortby(model, propertyName) {
			model.filter.reverse = model.filter.propertyName === propertyName ? !model.filter.reverse : false;
			model.filter.propertyName = propertyName;
		}

		return angular.extend(model, {
			formIsDirty: formIsDirty,
			setReadOnly: setReadOnly,
			save: _.partial(save, model),
			showFilterDialog: _.partial(showFilterDialog, model),
			loadCustomerStatuses: _.partial(loadCustomerStatuses, model),
			cancelSave: _.partial(cancelSave, model),
			selectCustomer: _.partial(selectCustomer, model),
			addCustomer: _.partial(addCustomer, model),
			loadCustomers: _.partial(loadCustomers, model),
			loadAccountStructures: _.partial(loadAccountStructures, model),
			loadStates: _.partial(loadStates, model),
			filterCustomerList: _.partial(filterCustomerList, model),
			deleteCustomer: _.partial(deleteCustomer, model),
			loadSites: _.partial(loadSites, model),
			loadBillingMethods: _.partial(loadBillingMethods, model),
			searchAccountsbyAccountNumber: _.partial(searchAccountsbyAccountNumber, model),
			selectAllFilterSites: _.partial(selectAllFilterSites, model),
			changeTab: _.partial(changeTab, model),
			showAddCustomer: _.partial(showAddCustomer, model),
			selectAllCustomerSites: _.partial(selectAllCustomerSites, model),
			filterReceiptList: _.partial(filterReceiptList, model),
			viewReceipt: _.partial(viewReceipt, model),
			sortReceiptsBy: _.partial(sortReceiptsBy, model),
			sortInvoicesBy: _.partial(sortInvoicesBy, model),
			sortby: _.partial(sortby, model),
			viewInvoice: _.partial(viewInvoice, model),
			printList: _.partial(printList, model),
			loadUnitEventHubCustomerId: _.partial(loadUnitEventHubCustomerId, model),
		});
	}

	var onRouteChangeOff = $scope.$on('$locationChangeStart', _.partial(dialogHelper.routeChange, $scope.vm.formIsDirty, acceptRouteChangeFunction));

	function acceptRouteChangeFunction() {
		onRouteChangeOff(); // Stop listening for location changes
		return angular.noop;
	}
}
